import { Theme } from '@mui/material';

export default {
	styleOverrides: {
		root: ({ theme }: { theme: Theme }) => ({
			borderRadius: '20px',
			padding: '16px',
			[theme.breakpoints.up('sm')]: {
				width: 'auto',
				columns: '3',
				display: 'block',
			},
		}),
	},
};
